import { http } from "../client";
export var updateMusicArchive = function (request) {
    return http.api
        .put("music-archives/".concat(request.musicArchiveId), {
        client_id: request.clientId
    })
        .then(function (response) { return response.data.data; });
};
